export default __webpack_public_path__ + "static/media/trash.75318e79.svg";